import {Inject, Injectable, Injector} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {BaseService} from '../depends/base.service';

@Injectable({
    providedIn: 'root'
})
export class NgxLoopReportService extends BaseService<any> {

    autoReportsAPI = 'https://reports.loop4.io/';

    constructor(public injector: Injector, @Inject('environment') private env) {
        super(injector, env, 'reports/datareport', (value) => {
            return value
        });
        this.apiPath = this.autoReportsAPI + 'reports/datareport';
        this.env = this.autoReportsAPI;
    }

    async getReportParameters(idReport: number) {
        let headers = await this.buildHeader();
        let path = this.autoReportsAPI + 'reports/report/parameters/' + idReport;
        return this.http.get(path, {headers: headers, observe: 'response'}).toPromise().then((response: HttpResponse<{
            data: any
        }>) => {
            return response.body.data;
        }).catch(reason => {
            this.willLogoutUser(reason);
            throw reason;
        });

    }

    async getReportContent(idReport: number, body) {
        let headers = await this.buildHeader();
        let path = this.autoReportsAPI + 'reports/report/content/' + idReport;
        return this.http.post(path, body, {
            headers: headers,
            observe: 'response',
            responseType: 'blob' as 'json'
        }).toPromise().then((response) => {
            return response;
        }).catch(reason => {
            this.willLogoutUser(reason);
            throw reason;
        });
    }

    async getReportData(body: any) {
        let header = await this.buildHeader();
        return this.http.post(this.apiPath + "-detail", body, {headers: header, observe: 'response'}).toPromise().then(
            (response: HttpResponse<any>) => {
                let data = response.body.data;

                //this.refreshToken(response.headers);
                return data;
            }
        ).catch(reason => {
            this.willLogoutUser(reason);
            throw reason;
        });
    }

    async getAutoReportData(idReport: number, body) {
        let headers = await this.buildHeader();
        let path = this.autoReportsAPI + "reports/report/content/" + idReport;
        return this.http.post(path, body, {
            headers: headers,
            observe: 'response',
            responseType: 'blob' as 'json'
        }).toPromise().then((response) => {
            return response
        }).catch(reason => {
            this.willLogoutUser(reason);
            throw reason;
        });
    }

    async getUserReports() {
        let header = await this.buildHeader();

        return this.http.get(`${this.apiPath}-list`, {headers: header, observe: 'response'}).toPromise().then(
            (response: HttpResponse<any>) => {
                let data = response.body.data;
                //this.refreshToken(response.headers);
                return data;
            }
        ).catch(reason => {
            this.willLogoutUser(reason);
            throw reason;
        });
    }

    async getExportData(body: any) {
        let header = await this.buildHeader();
        return this.http.post(`${this.apiPath}-export`, body, {headers: header, observe: 'response'}).toPromise().then(
            (response: HttpResponse<any>) => {
                let data = response.body.data;

                //this.refreshToken(response.headers);
                return data;
            }
        ).catch(reason => {
            this.willLogoutUser(reason);
            throw reason;
        });
    }

    async setReportFavorite(id: number, favorite: boolean) {
        let header = await this.buildHeader();
        let body = {
            favorite: favorite
        }
        return this.http.put(`${this.apiPath}-favorite/${id}`, body, {
            headers: header,
            observe: 'response'
        }).toPromise().then(
            (response: HttpResponse<any>) => {
                //this.refreshToken(response.headers)
            }
        ).catch(reason => {
            this.willLogoutUser(reason);
            throw reason;
        });
    }

    async getResource(id: any): Promise<any> {

        let headers = await this.buildHeader();
        console.log(headers);

        return this.http.get(this.apiPath + '/' + id, {headers: headers, observe: 'response'}).toPromise().then(
            (response: HttpResponse<{ data: any }>) => {
                console.log(response);
                let data = response.body.data;

                //this.refreshToken(response.headers);
                return this.jsonDataToModel(data);
            }
        ).catch(reason => {
            this.willLogoutUser(reason);
            throw reason;
        });
    }
}
